const options = {
  5: "bg-purple-700/5",
  10: "bg-purple-700/10",
  25: "bg-purple-700/25",
  50: "bg-purple-700/50",
  75: "bg-purple-700/75",
  90: "bg-purple-700/90",
  100: "bg-purple-700",
};

const from = {
  5: "from-purple-700/5",
  10: "from-purple-700/10",
  25: "from-purple-700/25",
  50: "from-purple-700/50",
  75: "from-purple-700/75",
  90: "from-purple-700/90",
  100: "from-purple-700",
};

export default function getBackgroundPurple700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
